import React from 'react';
import styled from 'styled-components';
import Select from '../../../../components/Select';
import RadioButtons from '../../../../components/RadioButtons';
import { I18n } from 'react-redux-i18n';

const ChartInputsBlocContainer = styled.div`
  margin-top: 50px;
  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .row:last-child {
    margin-top: 20px;
  }

  .label {
    margin-right: 20px;
  }

  .subRow {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .subRow:not(:last-child) {
    margin-right: 20px;
  }

  .chartInputRadioContainer {
    margin-right: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .chartInputRadioContainer div {
    display: flex;
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    .bigSelect {
      min-width: 150px;
      width: 150px;
    }

    .bigSelect > div {
      width: 150px;
      min-width: 150px;
    }
  }
`;

const ChartCompareBloc = ({
  compare,
  competitorNames,
  competitorName,
  onChange,
  handleRadioChange
}) => (
  <ChartInputsBlocContainer>
    <div className="row ignored-export">
      <div className="chartInputRadioContainer">
        <RadioButtons
          radioButtons={compare}
          returnValue
          onChange={(value) => handleRadioChange(value)}
        />
      </div>
      <div style={{ width: 280 }}>
        <Select
          value={competitorName}
          className="bigSelect"
          options={competitorNames}
          onChange={(selectedOption) =>
            onChange('competitorName', selectedOption)
          }
          placeholder={I18n.t('placeholderRival')}
          customStyles={{
            control: {
              height: '40px',
              minHeight: '40px',
              width: '280px',
              padding: 0
            },
            container: {
              width: 280,
              height: 40,
              padding: 0
            },
            valueContainer: {
              height: '40px !important',
              padding: 0
            }
          }}
          dropdownProps={{
            styles: `margin-left:-25px`,
            colorIcon: '#e25d34'
          }}
        />
      </div>
    </div>
  </ChartInputsBlocContainer>
);

export default ChartCompareBloc;
